import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import useDossierProgress from '../../../features/dossier/useDossierProgress'
import { useCaseDossier } from '../../../selectors/dossierSelectors'
import { fetchDashScene } from '../../../features/scene/sceneThunk'
import { useAppSelector } from '../../../app/hooks'
import { parentMeta } from '../../content/ContentBlock/type'
import { getFilePath } from '../../../shared/utils'

const useDashScene = () => {
  const dispatch = useDispatch()

  // =======================
  // Selectors
  // =======================
  const { data: zoneData } = useAppSelector((state) => state.zone)
  const {
    data: scene,
    loading: sceneLoading,
    error: sceneError,
  } = useAppSelector((state) => state.scene)
  const { data: userDossierData } = useAppSelector((state) => state.dossier)

  // progression hook watches poi response changes
  const dossier = useCaseDossier()
  useDossierProgress(dossier?.progress)

  // =======================
  // Effects
  // =======================
  useEffect(() => {
    dispatch(fetchDashScene())
  }, [userDossierData])

  // =======================
  // Props
  // =======================
  const content = useMemo(() => {
    if (!zoneData?.id || !scene?.id) return null
    return {
      filePath: getFilePath({
        filePath: scene?.filePath,
        zoneId: zoneData.id,
        sceneId: scene.id,
      }),
      parentMeta: {
        id: scene?.id,
        title: scene?.title,
      } as parentMeta,
    }
  }, [zoneData?.id, scene?.id])

  return {
    scene,
    content,
    actions: null,
    loading: sceneLoading,
    error: sceneError,
  }
}

export default useDashScene
